export const faqData = [
  {
    id: 1,
    question: '小ロットでも注文できますか？',
    answer: 'はい、1個からでも承っております。お客様のご要望に応じて柔軟に対応いたしますので、お気軽にご相談ください。',
  },
  {
    id: 2,
    question: '納期はどのくらいかかりますか？',
    answer: '印刷内容や数量によって異なりますが、通常は2週間程度です。お急ぎの場合は特急対応も可能ですので、ご相談ください。',
  },
  {
    id: 3,
    question: 'デザインの相談もできますか？',
    answer: 'もちろんです。お客様のイメージをお聞きしながら、最適なデザインをご提案いたします。デザインデータをお持ちでない場合もお任せください。',
  },
  {
    id: 4,
    question: '見積もりは無料ですか？',
    answer: 'はい、お見積もりは無料です。お電話またはお問い合わせフォームからお気軽にご依頼ください。',
  },
  {
    id: 5,
    question: '支払い方法は何がありますか？',
    answer: '銀行振込、現金払い、クレジットカード決済に対応しております。法人のお客様は請求書払いも可能です。',
  },
  {
    id: 6,
    question: 'サンプルを見ることはできますか？',
    answer: 'はい、実際の印刷サンプルをご覧いただけます。ご来社いただくか、郵送でのサンプル送付も可能ですので、お気軽にお申し付けください。',
  },
];
